// extracted by mini-css-extract-plugin
export default {"mainWrapper":"shipment-details_mainWrapper__WY0cq","formActionWrapper":"shipment-details_formActionWrapper__AemoR"};